import React from 'react';
import P from '@leverege/promise';
import { Plugins } from '@leverege/plugin';
import { PortalOverlay, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import { DataSources } from '@leverege/ui-attributes';
import ParentUtil from "../attributes/parent/ParentUtil.js";
import LoadingView from "../../views/LoadingView.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.view.BulkUpdateItem');
export default function BulkUpdateItem(props) {
  const {
    show,
    onClose,
    delegate,
    targets,
    relationship: {
      blueprint
    }
  } = props;
  const factory = Plugins.getFactory('BulkBlueprintForm');
  async function onSubmit({
    data: props,
    value
  }) {
    const close = LoadingView.showDialog(t('loadingDialog', {
      blueprintName: blueprint.namePlural
    }));
    const data = [];
    const rels = [];
    value.forEach(v => {
      if (v.attribute.valueType === 'parentRelationship') {
        rels.push(v);
      } else {
        delete v.attribute; // eslint-disable-line no-param-reassign
        data.push(v);
      }
    });

    // Promises should be separated, given that a parent setter might turn the delegate interface path invalid.
    const dataPromiseCreators = [];
    const relsPromiseCreators = [];
    targets.forEach(target => {
      if (data.length) {
        dataPromiseCreators.push(async () => {
          try {
            return GlobalState.dispatch(delegate.item(target.id).update({
              data
            }));
          } catch (error) {
            return error;
          }
        });
      }
      rels.forEach(rel => {
        relsPromiseCreators.push(async () => {
          try {
            const parentRef = ParentUtil.getParentAction(target, rel.attribute).itemRef(rel.value);
            const pActions = DataSources.getActions(parentRef);
            const gActions = pActions.child(rel.attribute.source.attribute.parentPath);
            if (rel.op === 'replace' && gActions.relationship.isOneToMany) {
              return GlobalState.dispatch(gActions.add(target.id));
            }
            if (rel.op === 'remove') {
              return GlobalState.dispatch(gActions.delete(target.id, null, null, {
                parentKey: rel.attribute.source.attribute.path
              })); // eslint-disable-line max-len
            }
            return null;
          } catch (error) {
            return error;
          }
        });
      });
    });
    const dataResults = await P.limit(dataPromiseCreators, {
      limit: 5
    });
    const relsResults = await P.limit(relsPromiseCreators, {
      limit: 5
    });
    const results = [...dataResults, ...relsResults];
    close();
    let hasSuccesses = false;
    let hasErrors = false;
    let idx = 0;
    do {
      if (results[idx] instanceof Error) {
        hasErrors = true;
      } else {
        hasSuccesses = true;
      }
      idx += 1;
    } while ((!hasSuccesses || !hasErrors) && idx < results.length);
    if (hasSuccesses && hasErrors) {
      Toast.success(t('someSuccess', {
        blueprintType: blueprint.type
      }));
      return;
    }
    if (hasSuccesses) {
      Toast.success(t('fullSuccess', {
        blueprintType: blueprint.type
      }));
      return;
    }
    if (hasErrors) {
      Toast.error([t('error', {
        blueprintType: blueprint.type
      })]);
    }
  }
  const BulkEditComponent = factory.create(
  // `${target?.type}.bulkUpdate`,
  'bulkUpdate', {
    blueprint,
    targets,
    onCancel: onClose,
    onClose,
    onSubmit,
    title: t('title', {
      count: targets.length,
      blueprintName: blueprint.namePlural
    }),
    titleIcon: blueprint.getIcon('updateDialogIcon') || blueprint.getIcon('screenIcon'),
    eventData: props
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: show,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    onClose: onClose,
    children: BulkEditComponent
  });
}